import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'

import api from '@/plugins/api'
import api4d from '@/plugins/api4d'

import VueCookies from 'vue-cookies'
import VueScreenSize from 'vue-screen-size'
import '@/assets/bootstrap/bootstrap-custom.css'

const app = createApp(App)

app.use(store)
    .use(api)
    .use(api4d)
    .use(router, app)
    .use(VueCookies)

if (typeof window !== 'undefined') {
    app.use(VueScreenSize)
}

store.$app = app

app.mount('#app')

